import React from "react";

const TetherBEPIcon = ({ className }) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(16 17) scale(1.7) translate(-16 -16)">
      <path
        d="M9.97961 7.33301H22.2674C22.5606 7.33301 22.8314 7.48494 22.9777 7.73142L26.5577 13.7661C26.7432 14.0791 26.6882 14.4741 26.4233 14.7278L16.5694 24.1714C16.2502 24.4773 15.7367 24.4773 15.4175 24.1714L5.57701 14.7406C5.30605 14.4809 5.25531 14.0744 5.45456 13.7595L9.28122 7.71206C9.43026 7.47654 9.69472 7.33301 9.97961 7.33301Z"
        fill="#69AC96"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6808 10.0273V11.7205H17.1805V12.8945C19.6389 13.0199 21.4833 13.5352 21.497 14.1528L21.4969 15.4403C21.4832 16.0579 19.6389 16.5732 17.1805 16.6986V19.5797H14.8563V16.6986C12.3979 16.5732 10.5535 16.0579 10.5398 15.4403L10.5399 14.1528C10.5536 13.5352 12.3979 13.0199 14.8563 12.8945V11.7205H11.356V10.0273H20.6808ZM16.0184 15.8141C18.6419 15.8141 20.8347 15.3784 21.3714 14.7966C20.9163 14.3032 19.2703 13.9148 17.1805 13.8082V15.0373C16.806 15.0565 16.4172 15.0665 16.0184 15.0665C15.6196 15.0665 15.2308 15.0565 14.8563 15.0373V13.8082C12.7666 13.9148 11.1205 14.3032 10.6654 14.7966C11.2021 15.3784 13.3949 15.8141 16.0184 15.8141Z"
        fill="white"
      />
    </g>

    <g
      transform="translate(1 -3)"
      clipPath="url(#clip0_1364_7122)"
    >
      <path
        d="M27 36C31.9706 36 36 31.9706 36 27C36 22.0294 31.9706 18 27 18C22.0294 18 18 22.0294 18 27C18 31.9706 22.0294 36 27 36Z"
        fill="#F3BA2F"
      />

      <path
        d="M24.8153 26.1023L27 23.9175L29.1859 26.1034L30.4571 24.8321L27 21.375L23.544 24.831L24.8153 26.1023ZM21.375 27L22.6463 25.7287L23.9175 27L22.6463 28.2713L21.375 27ZM24.8153 27.8978L27 30.0825L29.1859 27.8966L30.4571 29.1673L27 32.625L23.544 29.169L23.5423 29.1673L24.8153 27.8978ZM30.0825 27L31.3538 25.7287L32.625 27L31.3538 28.2713L30.0825 27ZM28.2892 26.9989H28.2904V27L27 28.2904L25.7113 27.0022L25.7091 27L25.7113 26.9983L25.9369 26.7722L26.0466 26.6625L27 25.7096L28.2898 26.9994L28.2892 26.9989Z"
        fill="black"
      />
    </g>

    <defs>
      <clipPath id="clip0_1364_7122">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(18 18)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TetherBEPIcon;
